import Box from "@mui/material/Box";
import SoulEqualizerLoader from "./SoulEqualizerLoader";


export default function LoadingPage() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        inset: 0,
        zIndex: 9999,
      }}
    >
      <SoulEqualizerLoader />
    </Box>
  );
}
